"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ni = exports.navItem = void 0;
const mithril_1 = __importDefault(require("mithril"));
const auth_1 = require("../utils/auth");
const helpers_1 = require("../utils/helpers");
const detail_link_1 = require("../widgets/detail_link");
const main_1 = require("./main");
const navItem = function (options, children) {
    return {
        view(_vnode) {
            let output;
            let route = options.route || "#", icon = options.icon, title = options.title;
            output = icon ? [(0, helpers_1.iconSpan)(icon)] : [];
            output = output.concat(title);
            let currentRoute = (0, detail_link_1.getCurrentRoute)();
            let active = (currentRoute == route);
            let attrs = Object.assign({
                href: route,
                onclick: (_evt) => {
                    main_1.Main.navIsOpen = false;
                }
            }, options.attrs || {});
            if (active) {
                attrs["class"] = (attrs["class"] || "") + " is-active";
            }
            if (children) {
                return (0, mithril_1.default)("li", [
                    (0, mithril_1.default)("a", attrs, output),
                    (0, mithril_1.default)("ul", children.map((x) => (0, mithril_1.default)(x)))
                ]);
            }
            else {
                return (0, mithril_1.default)("li", (0, mithril_1.default)("a", attrs, output));
            }
        }
    };
};
exports.navItem = navItem;
function ni(route, title, icon) {
    return (0, exports.navItem)({ route: route, title: title, icon: icon });
}
exports.ni = ni;
class Nav {
    view(vnode) {
        return [
            auth_1.Auth.mode().nav()
        ];
    }
}
exports.default = Nav;
